import userItem from './userAdministrationItem/index.vue';
import preloader from '@/components/preloader/index.vue';
import pagination from '@/components/pagination/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  components: {
    userItem,
    preloader,
    pagination,
    empty,
  },
  mixins: [
    helpers.general,
  ],
  data () {
    return {
      users: [],
      responseData: {},

      query: {
        page: 1,
        ppage: 16,
      },

      hasError: false,
      errorsBox: [],
      load: false,
    };
  },
  created () {
    this.getAllUsers();
  },
  methods: {
    /**
         * Get all users
         */
    getAllUsers () {
      this.load = true;

      Api.user
        .getAll(this.query)
        .then((response) => {
          if (response.data.Status) {
            this.users = response.data.Data;
            this.responseData = response.data;
          }
          this.load = false;
        });
    },

    /**
         * Download template csv
         */
    downloadTemplate () {
      Api.user
        .getTemplateCsv()
        .then((response) => {
          this.donwloadFileOnContent(response.data, 'user_template.csv');
        });
    },

    /**
         *
         * @param {*} event
         */
    sendPage (page) {
      this.query.page = page;
      this.getAllUsers();
    },

    /**
         * Upload file with list of users
         */
    uploadUserFile (event) {
      this.$validator.validate()
        .then((result) => {
          if (!result) {
            return this.$root.$emit('notification', {
              message: this.errors.items.find((item) => item.field === 'fileAttach').msg,
              type: 'error',
              show: true,
            });
          }

          const formData = new FormData();
          formData.append('import_template', event.target.files[0]);

          Api.user
            .uploadCsv(formData)
            .then((response) => {
              if (response.data.Status) {
                this.$root.$emit('notification', {
                  message: 'Users have been added',
                  type: 'info',
                  show: true,
                });

                this.getAllUsers();
              } else {
                this.hasError = true;
                this.$modal.show('error');
                this.errorsBox = response.data;
                this.$refs.uploadFile.value = '';
              }
            });
        });
    },
  },
};
